{
  "deprecatedBrowser": "Browser non supportato",
  "deprecatedBrowserHelpText": "Esegui l’aggiornamento alla versione più recente del browser per un’esperienza migliore."
}
